import React, {Component} from 'react';
import AppContext from "../../contexts/AppContext";

class ErrorAlert extends Component {

    static contextType = AppContext;

    render() {
        const {clearError, error, hasError} = this.context;

        let alertTypeClassName = ['APP_EXCEPTION', 'APPL_ERROR', 'SYS_ERROR'].includes(error.error_type) ? 'alert-danger' : 'alert-warning';

        return (
            <div>
                {hasError &&
                <div className="pt-3">
                    <div
                        className={"alert fade collapse show " + alertTypeClassName}
                        id="error-alert"
                        role="alert"
                    >
                        {error.message} <small className="ref-no">{error.ref_no}</small>

                        {/*{!(['APP_EXCEPTION', 'APPL_ERROR', 'SYS_ERROR'].includes(error.error_type)) &&*/}
                        {/*<button*/}
                        {/*    type="button"*/}
                        {/*    className="close"*/}
                        {/*    aria-label="Close"*/}
                        {/*    onClick={() => {*/}
                        {/*        clearError();*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    <span aria-hidden="true">&times;</span>*/}
                        {/*</button>*/}
                        {/*}*/}
                    </div>
                </div>
                }
            </div>
        );
    }
}

export default ErrorAlert;
